import { render } from "./HiTagger.vue?vue&type=template&id=6a154325"
import script from "./HiTagger.vue?vue&type=script&lang=js"
export * from "./HiTagger.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__